import React, { memo, useEffect, useState, useCallback } from 'react';
import MallOrdersCard from '../Card/MallOrdersCard/MallOrdersCard';
import { getGoodsList } from '../../../actions/order';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import InfiniteScroll from 'react-infinite-scroller';
import styles from './MallOrder.module.less';
import Loading from '../../../components/Loading/Loading';
import Default from '../../../static/order_lack.svg';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { logging, logPostInfo } from '../../../actions/log';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import DefaultLogin from '../DefaultLogin/DefaultLogin';

const selectMallOrders = createSelector(
  state => state.order,
  order => order,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ node }) => {
  const loginStatus = useLoginStatus();
  const history = useHistory();
  let nowPage = 1;
  const { mallOrders, mallLoading, mallTotal } = useSelector(selectMallOrders);
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
 
    if (loginStatus && mallOrders && mallOrders.length !== 0) {
      dispatch(
        logging({
          category: 'P',
          action: 'Mall_Orders',
          label: '',
          param2: {
            source: 'Mall_Orders',
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: 'Mall_Orders',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (loginStatus) {
      dispatch(getGoodsList({ page: 1, size: 24, refresh: true }));
    }
  }, [loginStatus])

  const loadMore = useCallback(() => {
    nowPage++;
    dispatch(getGoodsList({ page: nowPage, size: 24, refresh: false }));
  }, [nowPage]);

  const jumpOther = () => {
    history.push(`${CONTEXT}/recommend`);
  };
  return (
    <div className={styles.mall_orders}>
      {!loginStatus && <DefaultLogin />}
      {loginStatus && (
        <>
          {mallLoading && (
            <div className={styles.default}>
              <Loading />
            </div>
          )}

          {!mallLoading && (
            <>
              {mallOrders.length !== 0 && (
                <InfiniteScroll
                  page={1}
                  loadMore={loadMore}
                  hasMore={(mallOrders && mallOrders.length) < mallTotal}
                  loader={
                    <div className="loader" key={0}>
                      ----------加载中----------
                    </div>
                  }
                  initialLoad={false}
                  useWindow={false}
                  getScrollParent={() => node}
                >
                  {mallOrders.map((el, index) => (
                    <MallOrdersCard info={el} key={el.oid} />
                  ))}
                </InfiniteScroll>
              )}
              {mallOrders.length === 0 && (
                <div className={styles.default}>
                  <div>
                    <img src={Default} />
                  </div>
                  <div className={styles.describe}>
                    <span>您暂时还没有订单</span>
                    <span className={styles.jump_other} onClick={jumpOther}>
                      去逛逛
                    </span>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
});
